import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('Bitte eine gültige E-Mail-Adresse eingeben.'),
  password: z.string().min(1, 'Bitte das Passwort eingeben.'),
});
export type LoginForm = z.infer<typeof loginSchema>;

export const registerSchema = z.object({
  organizationName: z.string().min(2, 'Bitte den Firmennamen eingeben.').max(120),
  displayName: z.string().min(2, 'Bitte Ihren Namen eingeben.').max(120),
  email: z.string().email('Bitte eine gültige E-Mail-Adresse eingeben.'),
  password: z.string().min(12, 'Das Passwort muss mindestens 12 Zeichen haben.').max(128),
});
export type RegisterForm = z.infer<typeof registerSchema>;
